export function getLocationHeader(response) {
    const location = response.headers.get('Location');
    if (!location) {
        throw new Error('No Location header in response');
    }
    return location;
}
//# sourceMappingURL=getLocationHeader.js.map